import { render } from "./LocalView.vue?vue&type=template&id=26900dcb&scoped=true"
import script from "./LocalView.vue?vue&type=script&lang=js"
export * from "./LocalView.vue?vue&type=script&lang=js"

import "./LocalView.vue?vue&type=style&index=0&id=26900dcb&lang=scss&scoped=true"

import exportComponent from "/media/ctis/developer/WorkSpaceFront/eventos-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26900dcb"]])

export default __exports__